module.exports = {
    register: 'register',
    login: '/account/login',
    logout: 'logout',
    user: 'users/me',
    company: '/companies',
    company_notes:"/notes",
    coworker: '/coworkers',
    migration:'/migration',
    region:'/master/region'
}